import type { ModulesAndAgendasState } from '../index';
import { isSectionNameUnique } from './addNewSection';
import { findSectionIndex, findTabIndex } from 'utils/section/tabSection.ts';
import { recalcSectionItems, setAllActionsInputs } from 'utils/section/items.ts';
import type { UpdateSectionActionInputs } from 'types';

export interface Payload {
  value: { name: string; newName: string; description?: string; collapsed: boolean; hasActionInputs: UpdateSectionActionInputs };
  currentTab: number;
}

export const renameSection = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { value, currentTab } = payload;
  const tabSections = state.tabSections;

  if (value.newName !== value.name && !isSectionNameUnique(tabSections, value.newName ?? '')) {
    throw new Error('exists');
  }

  const currentTabIndex = findTabIndex(tabSections, currentTab);

  if (currentTabIndex === -1) throw new Error('Invalid tab index');

  const sectionIndex = findSectionIndex(tabSections[currentTabIndex].sections, value.name);

  if (sectionIndex === -1) throw new Error('Invalid section index');

  const section = tabSections[currentTabIndex].sections[sectionIndex];

  section.name = value.newName;
  if (value.description !== undefined) {
    section.description = value.description;
  }
  section.collapsed = value.collapsed;

  if (value.hasActionInputs === 'all') {
    setAllActionsInputs(section.formItemTabs, true);
  }

  if (value.hasActionInputs === 'none') {
    setAllActionsInputs(section.formItemTabs, false);
  }
  section.items = recalcSectionItems(section.formItemTabs);
};
